<script setup lang='ts'>
import useCheckout from '@/apps/checkout/composables/useCheckout';
import {computed} from 'vue';
const {wooCheckout, step, wooCart} = useCheckout();
const paymentDescriptor = computed(() => {
	return wooCart.cart.value?.extensions.itlp?.payment_method_descriptions['axepta'];
});

const isPaymentMethodEnabled = computed(() => {
	return wooCart.cart.value?.payment_methods.includes("axepta");
});

const isPaymentMethodSelected = computed(() => {
	return wooCheckout.selectedPaymentMethodId.value == 'axepta';
});

</script>
<template lang='pug'>
button.itlp-checkout-payment-row(
	v-if='isPaymentMethodEnabled'
	:class="{'itlp-checkout-payment-selected': isPaymentMethodSelected}"
	@click='wooCheckout.selectedPaymentMethodId.value = "axepta"'
	:aria-label="paymentDescriptor?.title"
	:aria-pressed="isPaymentMethodSelected? 'true' : 'false'"
)
	.itlp-checkout-payment.itlp-checkout-payment-bacs
		.itlp-checkout-payment-fake-radio 
		.itlp-checkout-payment-title {{paymentDescriptor?.title}}
		.itlp-checkout-payment-description {{paymentDescriptor?.description}}
</template>